import { NavigateFunction } from "react-router-dom";

export function handleInternalSpaNavigation(
  href: string,
  event: Event,
  navigate: NavigateFunction,
): boolean {
  const allowedPrefixes = [
    "/legislacao/",
    "/doutrina/",
    "/jurisprudencia/",
    "/modelos/",
  ];

  const isInternal = allowedPrefixes.some((prefix) => href.startsWith(prefix));

  if (!isInternal) return false;

  event.preventDefault();

  navigate(href);

  return true;
}
